import { OffersConnector } from '@Atomic/organisms/category/CategoryContent';

const Category = () => <OffersConnector type="category" />;

export default Category;
